import React, { useEffect, useMemo, useState } from 'react';
import Modal from 'components/Tvendo/Common/ModalBase';
import { Autocomplete } from '@material-ui/lab';
import { TextField } from '@material-ui/core';
import { wsGetAll } from 'services/WService';

function AddUserModal(props) {
  const { showNotify, onSave, addedUsers } = props;
  const [users, setUsers] = useState([]);
  const [selectedUser, setSelectedUser] = useState();

  function setOpen() {
    props.setOpen({ open: false });
  }

  async function listUsers() {
    let res = await wsGetAll('oauth/user?with_notification_email=Y');
    if (res.success) {
      setUsers(res.data);
    }
  }

  async function onSubmit() {
    onSave({ oauth_user_id: selectedUser.id });
    setSelectedUser(undefined);
  }

  useEffect(() => {
    listUsers();
  }, []);

  const filteredUsers = useMemo(() => {
    return users.filter((user) => {
      return addedUsers.find((addUser) => user.id === addUser.id) === undefined;
    });
  }, [addedUsers, users]);

  return (
    <Modal
      title="Suscribir usuario a notificación: "
      model={props.model}
      setOpen={setOpen}
      showNotify={showNotify}
      entity={''}
      onSubmit={onSubmit}
    >
      <Autocomplete
        fullWidth
        renderInput={(params) => (
          <TextField {...params} label="Usuario" name="oauth_user_id" required />
        )}
        options={filteredUsers}
        getOptionLabel={(option) => {
          if (option === null) return '';
          return `${option.name} - ${option.email} - ${option.notification_email}`;
        }}
        value={users.find((user) => user.id === selectedUser?.id) || null}
        onChange={(e, item) => {
          if (item === null) {
            setSelectedUser(undefined);
            return;
          }
          setSelectedUser(item);
        }}
      />
    </Modal>
  );
}

export default AddUserModal;
